import { styled } from '@mui/material';

export const Wrap = styled('div')(({ theme }) => ({
	fontSize: '24px',
	fontWeight: '600',
	lineHeight: '32px',
	padding: '16px;',
	display: 'flex',
	alignItems: 'center',
	gap: '8px',

	[theme.breakpoints.down(960)]: {
		padding: '8px',
	},
}));
